import { useDispatch, useSelector } from 'react-redux';
import { canUploadAttachments } from '../attachments/selectors/canUploadAttachments';
// @ts-expect-error Untyped Module
import { attachmentError } from '../file-uploads/actions/attachmentError';
import { selectAttachmentFile } from '../file-uploads/actions/selectAttachmentFile';
import { INVALID_FILE_TYPE } from '../file-uploads/constants/attachmentErrors';
// @ts-expect-error Untyped Module
import MeetingsLinkContainer from '../meetings-links/containers/MeetingsLinkContainer';
// @ts-expect-error Untyped Module
import { getSelectedThread } from '../selected-thread/selectors/getSelectedThread';
// @ts-expect-error Untyped Module
import UnifiedThreadViewWrapperWithDragUpload from '../thread-view/components/UnifiedThreadViewWrapperWithDragUpload';
import ConnectedUnifiedThreadView from '../thread-view/containers/ConnectedUnifiedThreadView';
import { isPersistedThread } from '../threads/operators/isPersistedThread';
import { getThreadId } from '../threads/operators/threadGetters';
import { getIsPortal53 } from '../widget-data/operators/getIsPortal53';
import { getShouldDisableAttachments } from '../widget-ui/selectors/getShouldDisableAttachments';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadView = ({
  onSetMessageTextExternally
}) => {
  const shouldDisableDragAndDropUpload = useSelector(state => !isPersistedThread(getSelectedThread(state)) || getShouldDisableAttachments(state) || !canUploadAttachments(state, {
    thread: getSelectedThread(state)
  }));
  const selectedThread = useSelector(getSelectedThread);
  const dispatch = useDispatch();
  const onDropFiles = files => {
    if (!files || !files.length) {
      return;
    }
    const file = files[0];
    if (/\.har$/.test(file.name) && !getIsPortal53()) {
      dispatch(attachmentError(INVALID_FILE_TYPE, getThreadId(selectedThread)));
    } else {
      dispatch(selectAttachmentFile({
        file,
        thread: selectedThread,
        source: 'drag_and_drop'
      }));
    }
  };
  return /*#__PURE__*/_jsxs(UnifiedThreadViewWrapperWithDragUpload, {
    onDropFiles: onDropFiles,
    disabled: shouldDisableDragAndDropUpload,
    children: [/*#__PURE__*/_jsx(MeetingsLinkContainer, {}), /*#__PURE__*/_jsx(ConnectedUnifiedThreadView, {
      onSetMessageTextExternally: onSetMessageTextExternally
    })]
  });
};
ThreadView.displayName = 'ThreadView';
export default ThreadView;